import "./bootstrap43"
import I18n from "i18n-js"
window.I18n = I18n
import * as iziToast from "izitoast/dist/js/iziToast.min.js"
window.iziToast = iziToast
import "./sweetalert.js"
